import React from 'react'
import { connect } from 'react-redux'
import ChatSection from './ChatSection'
import ReviewSection from '../feedbackdetail/ReviewSection'
import ActionSection from './ActionSection'
import FeedbackSection from '../feedbackdetail/FeedbackSection'
import NoteSection from '../feedbackdetail/NoteSection'
import AttachmentSection from '../feedbackdetail/AttachmentSection'
import AdminAttachmentSection from '../feedbackdetail/AdminAttachmentSection'
import TagsSection from '../feedbackdetail/TagsSection'
import {
    genEmailButton,
    getAttachmentsUrls,
    getChatStatus,
    getRequestedVia,
    getStarsJSX,
    warnNoChat
} from '../redux/FeedbackRedux'
import Loading from './Loading'
import Alert from '../Alert'
import DateFormatter from '../Classes/DateFormatter'
import MarketingSection from '../feedbackdetail/MarketingSection'
import MobileFeedbackPreview from './MobileFeedbackPreview'

/**
 * Keep a Bootstrap 4 tooltip's text in sync with its React-rendered `data-title`.
 *
 * Bootstrap caches the title in `data-original-title` on first init and never
 * re-reads `data-title` afterwards, so a tooltip whose `data-title` changes
 * between renders (e.g. the email/call quick-action icons flipping to
 * "No email address provided" when navigating to a feedback without an email)
 * would otherwise show stale text. Mirror the current `data-title` into
 * `data-original-title` (the attribute Bootstrap actually reads on hover) on
 * every (re)init. Same approach used in FormDropdown.js.
 */
function syncTooltipTitle (element) {
    const dataTitle = jQuery(element).attr('data-title')
    if (typeof dataTitle === 'string') {
        jQuery(element).attr('data-original-title', dataTitle)
    }
    jQuery(element).attr('title', jQuery(element).attr('data-original-title'))
}

class FeedbackDetail extends React.Component {
    constructor(props) {
        super(props);
    }

    handleBackClick() {
        const $body = jQuery('body');
        if ($body.width() <= 1000) {
            if ($body.find('.feedback-detail-scroll').hasClass('is-hidden-mobile')) {
                $body.find('.feedback-list').addClass('is-hidden-mobile');
                $body.find('.dashboard-stats').addClass('is-hidden-mobile');
                $body.find('.feedback-detail-scroll').removeClass('is-hidden-mobile');
            } else if ($body.find('.feedback-list').hasClass('is-hidden-mobile')) {
                $body.find('.feedback-detail-scroll').addClass('is-hidden-mobile');
                $body.find('.feedback-list').removeClass('is-hidden-mobile');
                $body.find('.dashboard-stats').removeClass('is-hidden-mobile');
            }
        }
    }

    handleChatBubbleClick() {
        if (this.props.feedback.is_include_contact && this.props.feedback.user.phone) {
            this.props.toggleChat();
        } else {
            warnNoChat(this.props.feedback.is_include_contact, this.props.dispatch);
        }
    }

    componentDidMount() {
        $('[data-toggle="tooltip"], [data-toggle-second="tooltip"]').each(function () {
            jQuery(this).tooltip({ html: true, placement: 'bottom',
                container: 'body',
                boundary: 'window'
            });
        });

        $('[data-toggle="tooltip"], [data-toggle-second="tooltip"]').each(function () {
            syncTooltipTitle(this)
        });

    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        $('[data-toggle="tooltip"], [data-toggle-second="tooltip"]').each(function () {
            jQuery(this).tooltip({ html: true, placement: 'bottom',
                container: 'body',
                boundary: 'window'
            });
        });

        $('[data-toggle="tooltip"], [data-toggle-second="tooltip"]').each(function () {
            syncTooltipTitle(this)
        });

    }

    render() {
        const attachments = getAttachmentsUrls(this.props.feedback);
        var moment = require('moment-timezone');
        var response_via_text = getRequestedVia(this.props.feedback);
        const { chat_alert, chat_button_text } = getChatStatus(this.props.feedback);
        const stars = getStarsJSX(this.props.feedback.ratethisbizrating ? this.props.feedback.ratethisbizrating.rating : null);
        var email_forward = genEmailButton(this.props.feedback, 'dropdown-item text-primary');

        var tags =
            this.props.state.business &&
            this.props.state.business.tags &&
            this.props.state.business.tags.length > 0;

        var archive_button = <a href="#" onClick={this.handleArchiveClick} className="btn btn-sm btn-outline-danger d-inline-block archive-button text-capitalize"><i className="fas fa-archive mr-1"></i> { __('Archive') }</a>;
        if (this.props.feedback.is_archived) {
            archive_button = <a href="#" onClick={this.handleArchiveClick} className="btn btn-sm btn-warning d-inline-block archive-button text-capitalize"><i className="fas fa-archive mr-1"></i> { __('Unarchive') }</a>;
        }

        let main_classes = "col-12 px-2";

        const formattedTime = DateFormatter.formatDate(this.props.feedback.created_at, this.props.state.business.call_at_timezone, this.props.state.app_locale);
        let dow = (this.props.feedback.dow !== "" ? this.props.feedback.dow + ", " : "") + formattedTime;

        // Only render the alert wrapper when an alert for this location is actually active.
        // Alert renders null otherwise, but the empty flex/mt-2 wrapper still reserves vertical
        // space at the top of the page (visible as a gap on the logged-out mobile view) (RTF-4990).
        const feedbackAlert = this.props.state.alert.alert;
        const showFeedbackAlert = feedbackAlert && feedbackAlert.alert && feedbackAlert.alert_location === 'feedback_detail';

        return (
            <div className={main_classes} id={this.props.center ? "center-detail" : null}>
                <Loading location={'feedbackSection'} />
                {!this.props.state.hide_initial_feedbacks &&
                    <button className="btn btn-sm btn-primary d-none mb-3" onClick={this.handleBackClick.bind(this)}><i className="fas fa-arrow-circle-left mr-1"></i> { __('Back') }</button>
                }

                {showFeedbackAlert &&
                    <div className="d-flex justify-content-center">
                        <div className="mt-2" style={{width: "60%"}}>
                            <Alert alert={this.props.state.alert.alert} location={'feedback_detail'}/>
                        </div>
                    </div>
                }
                {/* <StatusSection feedback={this.props.feedback} current_user={this.props.current_user} /> */}
                <div className={'d-block d-xl-none feedback-details-wrapper'}>
                    {!this.props.showChat ?
                        <>
                            <div className={'feedback-details-wrapper-section'}>
                                <FeedbackSection feedback={this.props.feedback} current_user={this.props.current_user}
                                                 dispatch={this.props.dispatch}/>

                                {/* time section */}
                                <div className={'d-block d-xl-none'}>
                                    <span className="d-block d-xl-none">{dow}</span>
                                    {this.props.feedback.rating_request_sent_at_label &&
                                        <span className="d-block text-muted rating-request-sent">
                                            {__('From a rating request text message sent')} {this.props.feedback.rating_request_sent_at_label}
                                        </span>
                                    }
                                </div>

                            </div>
                            <div className={'feedback-details-wrapper-section'}>
                                <ActionSection/>
                            </div>
                            <div className={'feedback-details-wrapper-section'}>
                                <ReviewSection feedback={this.props.feedback} current_user={this.props.current_user}/>
                            </div>

                            {/* Marketing Testimonials */}
                            {this.props.feedback.marketing &&
                                <div className={'feedback-details-wrapper-section'}>
                                    <MarketingSection marketing={this.props.feedback.marketing} />
                                </div>
                            }

                            <div className={'feedback-details-wrapper-section'} data-showonprint={this.props?.feedback?.notes?.length > 0}>
                                <NoteSection feedback={this.props.feedback} user_id={this.props.current_user}
                                             ref={this._notesection} current_user={this.props.current_user}/>
                            </div>

                            {attachments?.length > 0 &&
                                <div className={'feedback-details-wrapper-section'}>
                                    <AttachmentSection attachments={attachments} feedback={this.props.feedback} current_user={this.props.current_user} />
                                </div>
                            }

                            {this.props.current_user && tags ?
                                <div className={'feedback-details-wrapper-section'} data-showonprint={this.props?.feedback?.feedback_tags?.length > 0}>
                                    <TagsSection feedback={this.props.feedback} current_user={this.props.current_user}/>
                                </div> : null
                            }

                            <div className={'feedback-details-wrapper-section feedback-details-wrapper-section-last'}
                                 data-showonprint={
                                    this.props?.feedback?.feedback_attachments?.length > 0 &&
                                    !this.props.feedback.feedback_attachments.every(
                                        (att) => att.type === 'feedback_attachment_ext'
                                )}
                            >
                                <AdminAttachmentSection feedback={this.props.feedback}
                                                        current_user={this.props.current_user}/>
                            </div>

                            <div className={'feedback-details-chat-icon'} onClick={this.handleChatBubbleClick.bind(this)} data-disabled={!(this.props.feedback.is_include_contact && this.props.feedback.user.phone)}>
                                <img src="/img/chat-icon.svg" alt={'Chat Icon'}/>
                            </div>
                        </> : <div className={'chat-section-m'}>
                            <div className={'wrapper d-flex'}>
                                <div className="chat-close-icon" onClick={this.props.toggleChat}>&#x2715;</div>
                                <MobileFeedbackPreview feedback={this.props.feedback}/>
                                <ChatSection feedback={this.props.feedback} current_user={this.props.current_user}
                                             dispatch={this.props.dispatch} />
                            </div>
                        </div>}

                    {/* show chat for print */}
                    <div className={'chat-section-m chat-section--print'}>
                        <div className={'wrapper d-flex'}>
                            <div className="chat-close-icon" onClick={this.props.toggleChat}>&#x2715;</div>
                            <ChatSection feedback={this.props.feedback} current_user={this.props.current_user}
                                         dispatch={this.props.dispatch} />
                        </div>
                    </div>
                </div>
                <div className="card feedback-detail mt-2 d-none d-xl-block">
                    <div className="row">
                        {/* Actions Bar*/}
                        <div className="col-12">
                            <ActionSection />
                        </div>

                        {/* Feedback Details */}
                        <div className="col-8 pr-0 feedback-detail-left-section">
                            <FeedbackSection feedback={this.props.feedback} current_user={this.props.current_user} dispatch={this.props.dispatch} />

                            {this.props.feedback.marketing &&
                                <MarketingSection marketing={this.props.feedback.marketing} />
                            }

                            <NoteSection feedback={this.props.feedback} user_id={this.props.current_user} ref={this._notesection} current_user={this.props.current_user} />
                            <AttachmentSection attachments={attachments} feedback={this.props.feedback} current_user={this.props.current_user} />
                            {this.props.current_user && tags ? <TagsSection feedback={this.props.feedback} current_user={this.props.current_user} /> : null}
                            <AdminAttachmentSection feedback={this.props.feedback} current_user={this.props.current_user} />
                        </div>
                        <div className="desktop-chat col-4 pl-0 border-left">
                            <ChatSection feedback={this.props.feedback} current_user={this.props.current_user} dispatch={this.props.dispatch} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
function mapStateToProps(state) {
    return {
        feedback: state.feedback_detail,
        current_user: state.current_user,
        state: state
    }
}

export default connect(mapStateToProps)(FeedbackDetail)
